<!-- 报表信息 -->
<template>
  <div id="nologin-main">
    <h1>未登录</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style>
</style>
